// extracted by mini-css-extract-plugin
module.exports = {"params":"TrainingsExportDialog_params__3cNUS"};